import styled from "styled-components";

export const CheckoutBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  position: relative;
  background-color: #FE2F67;
`

export const CheckoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  align-items: flex-start;
  justify-content: center;
  width: calc(95% - 20px);
  margin: 20px;
  background-color: #FFF;
  border-radius: 20px;
  overflow-y: scroll;
`

export const CheckoutBackContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #2E3A59;
  font-size: 2vh;
  cursor: pointer;
`

export const CheckoutBackArrow = styled.i`
  margin-right: 10px;
`

export const CheckoutBackText = styled.p`
  
`

export const CheckoutBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  flex: 1;
  margin: 20px 0;
  
  @media (max-width: 1300px){
    flex-direction: column;
  }
`
